import { render, staticRenderFns } from "./FourOhThree.vue?vue&type=template&id=5129b874&scoped=true"
import script from "./FourOhThree.vue?vue&type=script&lang=js"
export * from "./FourOhThree.vue?vue&type=script&lang=js"
import style0 from "./FourOhThree.vue?vue&type=style&index=0&id=5129b874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5129b874",
  null
  
)

export default component.exports